/**
 * @generated SignedSource<<eb197dd235a653c4ce1db672f4e9fe1d>>
 * @relayHash c99e2808a228eb92727148803707fdaf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7ec205f40b7500fb7c7a9b071c68e81d587fa99bea362fe137a7dc948eb646b5

import type { ConcreteRequest } from 'relay-runtime';
export type UserContextQuery$variables = Record<PropertyKey, never>;
export type UserContextQuery$data = {
  readonly user: {
    readonly displayName: string | null | undefined;
    readonly emails: ReadonlyArray<{
      readonly isPrimary: boolean | null | undefined;
      readonly value: string | null | undefined;
    } | null | undefined> | null | undefined;
    readonly id: string | null | undefined;
  } | null | undefined;
};
export type UserContextQuery = {
  response: UserContextQuery$data;
  variables: UserContextQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": "user",
    "args": [
      {
        "kind": "Literal",
        "name": "current",
        "value": true
      }
    ],
    "concreteType": "AtlassianUser",
    "kind": "LinkedField",
    "name": "confluence_atlassianUser",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "displayName"
      },
      {
        "concreteType": "AtlassianUserEmail",
        "kind": "LinkedField",
        "name": "emails",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "value"
          },
          {
            "kind": "ScalarField",
            "name": "isPrimary"
          }
        ]
      }
    ],
    "storageKey": "confluence_atlassianUser(current:true)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "UserContextQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "UserContextQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "c99e2808a228eb92727148803707fdaf",
    "id": "7ec205f40b7500fb7c7a9b071c68e81d587fa99bea362fe137a7dc948eb646b5",
    "metadata": {},
    "name": "UserContextQuery",
    "operationKind": "query",
    "text": "query UserContextQuery{user:confluence_atlassianUser(current:true){id,displayName,emails{value,isPrimary}}}"
  }
};
})();

(node as any).hash = "5aa8ba909d08e6a2648a02f59bca880f";

export default node;
